import { RefreshEnvOnPipe } from '@morningtrain/react-resources'

export default function RefreshForcedNotificationsOnPipe () {
  return (
    <RefreshEnvOnPipe path='forced_notifications' namespace='api' resourceName='users.profile' operationName='forced_notifications' />
  )
}
